import { useTranslation } from "react-i18next";
import { FormHook } from "../hook/useForm";
import { UsersFilters } from "../models/interfaces";
import { useCookies } from "react-cookie";
import { useState } from "react";
import { FilterWrapper } from "../shared/all.styles";
import { Box, Button, MenuItem, Stack, TextField } from "@mui/material";
import { Typography } from "../shared/typography";



interface Props {
  clearFilters: () => void;
  filter: UsersFilters | undefined;
  setFilter: (filter:UsersFilters) => void;
  defaultFilters: UsersFilters;
  submit: () => void
}

const FILTER_STORE_KEY = 'user'

const UserFilters = ({
  clearFilters,
  filter,
  setFilter,
  submit,
}: Props) => {
  const { t } = useTranslation();

  const handleClearFilters = () => {
    clearFilters();
  };

  return (
    <>
      <FilterWrapper grayBackground>
        <Stack direction={'row'} spacing={3} alignItems={'center'}>
          <Typography variant="subtitle1">{t('user.filters')}</Typography>
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'gray',
              height: '40px',
              display: 'block',
              opacity: 0.8,
            }}
          />
          <Stack direction={'row'} spacing={3} alignItems={'center'} width={'100%'}>
            <TextField
              value={filter?.email_prefix || ''}
              label={t('user.email')}
              fullWidth
              sx={{ maxWidth: '35%', borderRadius: '30px' }}
              onChange={(e) => setFilter({...filter, email_prefix: e.target.value})}
            />
            
          </Stack>
          <Stack direction={'row'}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleClearFilters}
              sx={{ mr: '30px', whiteSpace: 'nowrap' }}
            >
              {t('actions.clearFilters')}
            </Button>
            <Button onClick={submit} variant="contained" color="primary">
              {t('actions.search')}
            </Button>
          </Stack>
        </Stack>
      </FilterWrapper>
    </>
  );
};

export default UserFilters;
